// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".curtain-text[data-v-8752a55e]{color:currentColor;font-weight:900}", "",{"version":3,"sources":["webpack://./src/components/BusyStateCurtain.scoped.scss"],"names":[],"mappings":"AAAA,+BAA+B,kBAAkB,CAAC,eAAe","sourcesContent":[".curtain-text[data-v-8752a55e]{color:currentColor;font-weight:900}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
